module.exports = __webpack_public_path__ + "static/media/audiotrackbar-orange.28c28199.svg";